module.exports = __webpack_public_path__ + "static/media/imac-scrn-ppc.f0f2ec72.jpg";